<template>
  <div></div>
</template>

<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
const timezone = require('dayjs/plugin/timezone') // dependent on utc plugin

dayjs.extend(utc)
dayjs.extend(timezone)

export default {
  name: 'BaseMessage',
  props: {
    content: {
      type: Object,
      required: true
    },
    date: {
      type: String,
      required: false
    }
  },
  methods: {
      formatDate (value) {
        const format = 'HH:mm'
        return dayjs.utc(value).local().format(format)
      }
  }
}
</script>
